<template>
  <div v-if="visible" class="bm-mask" @click.self="onCancel">
    <div class="bm keno-bet-modal">
      <!-- 顶栏：右上角期号（白字） -->
      <div class="bm-head">
        <div class="h-spacer"></div>
        <div class="h-issue">#{{ issueShort }}</div>
        <button class="h-x" @click="onCancel">x</button>
      </div>

      <div class="bm-body">
        <!-- 顶部信息区：参考用户 HTML 结构 -->
        <div class="wraper-info">
          <table class="info-table">
            <tbody>
              <tr>
                <td><span class="ti-play">{{ playLabel }}</span></td>
                <td><span class="ti-time">{{ timeText }}</span></td>
              </tr>
              <tr>
                <td><span class="ti-range">{{ rangeText }}</span></td>
                <td><span class="ti-odds">{{ oddsText }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- stake：260*42 蓝色 -->
        <div class="stake-bar-v3">
          <span class="stake-text">Stake : </span>
          <input
              ref="stakeInput"
              class="stake-input-v3"
              type="text"
              v-model="stakeStr"
              @input="onStakeInput"
              placeholder=""
          />
        </div>

        <!-- chips：球 55*55 -->
        <div class="chips wraper-bet">
          <button
              v-for="(c, idx) in chips"
              :key="idx"
              class="chip button-bet"
              @click="addChip(c)"
          >
            <span class="title-button-bet">{{ fmtChip(c) }}</span>
          </button>
        </div>

        <hr class="bm-hr">

        <!-- Max/Limit -->
        <div class="bm-info">
          <p class="max-payout-line">
            {{$t('lotto.MaxPayout')}} : <span class="val">{{ maxPayoutText }}</span>
          </p>
          <p class="max-payout-line">
            {{$t('lotto.LimitBetting')}} : <span class="val limit">{{ minBetText }}-{{ maxBetText }}</span>
          </p>
        </div>
      </div>

      <!-- 底部按钮：移动到 body 外面以精确控制高度 -->
      <div class="bm-actions">
        <button class="btn bet" @click="onBet">{{$t('lotto.BET')}}</button>
        <button class="btn cancel" @click="onCancel">{{$t('lotto.CANCEL')}}</button>
        <button class="btn reset" @click="onReset">{{$t('lotto.RESET')}}</button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "BetModal",
  props: {
    visible: { type: Boolean, default: false },
    issueShort: { type: String, default: "-" },
    timeText: { type: String, default: "" },

    // 展示信息
    playLabel: { type: String, default: "" },   // เช่น "តូច" / "ធំ" / "1".."5"
    rangeText: { type: String, default: "" },   // "210-810"
    oddsText: { type: String, default: "" },    // "1.95"

    // 限额
    minBet: { type: [Number, String], default: 0 },
    maxBet: { type: [Number, String], default: 0 },

    // 可选：最大派奖（如果你后端暂时没有，就传 "-"）
    maxPayoutText: { type: String, default: "-" },

    // 快捷金额
    chips: {
      type: Array,
      default: function () {
        return [1000, 2000, 5000, 10000, 20000, 50000, 200000, 500000];
      }
    }
  },

  data() {
    return { stakeStr: "" };
  },

  computed: {
    minBetText() {
      return String(this.minBet || 0);
    },
    maxBetText() {
      return String(this.maxBet || 0);
    }
  },

  watch: {
    visible(v) {
      if (v) {
        this.$nextTick(() => {
          this.stakeStr = "";
          if (this.$refs.stakeInput) this.$refs.stakeInput.focus();
        });
      }
    }
  },

  methods: {
    fmtChip(n) {
      const v = Number(n);

      // ✅ 金额 -> i18n key 映射（你已有翻译）
      const map = {
        1000: "lotto.qian",
        2000: "lotto.liangqian",
        5000: "lotto.wuqian",
        10000: "lotto.wan",
        20000: "lotto.liangwan",
        50000: "lotto.wuwan",
        200000: "lotto.ershiwan",
        500000: "lotto.wushiwan"
      };

      const key = map[v];
      if (key && this.$t) {
        const txt = this.$t(key);
        // 如果有翻译就用翻译，否则回退数字
        if (txt && txt !== key) return txt;
      }

      // fallback：正常数字格式化
      try {
        return v.toLocaleString();
      } catch (e) {
        return String(n);
      }
    },

    cleanNumber(s) {
      return String(s || "").replace(/[^\d]/g, "");
    },

    onStakeInput() {
      this.stakeStr = this.cleanNumber(this.stakeStr);
    },

    addChip(n) {
      const cur = Number(this.cleanNumber(this.stakeStr) || 0);
      const next = cur + Number(n || 0);
      this.stakeStr = String(next);
    },

    onReset() {
      this.stakeStr = "";
      this.$nextTick(() => {
        if (this.$refs.stakeInput) this.$refs.stakeInput.focus();
      });
    },

    onCancel() {
      this.$emit("cancel");
    },

    onBet() {
      const amount = Number(this.cleanNumber(this.stakeStr));
      this.$emit("confirm", { amount });
    }
  }
};
</script>

<style scoped>
.bm-mask{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  align-items: flex-start;
  padding-top: 120px;
  justify-content: center;
}

.bm{
  /* ✅ 整体大小 309*389 (40+306+43) */
  width: 309px;
  height: 389px;

  background: #ffffff;
  box-shadow: 0 8px 22px rgba(0,0,0,.25);
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #3C5AA0;
  transform: translate(-45%, 0); /* 50%居中，再多往左 5% */
  display: flex;
  flex-direction: column;
}

.bm-head{
  width: 309px;
  height: 40px;              /* ✅ 309*40 */
  background: #3C5AA0;
  color: #FFFFFF;

  display: flex;
  align-items: center;       /* 垂直居中 */
  justify-content: space-between;

  padding: 0 10px;           /* 左右稍微宽一点更像图一 */
  font-weight: 900;
  box-sizing: border-box;
}

.h-spacer{ flex: 1; }
.h-issue{
  color: #fff;         /* ✅ 期号白字 */
  font-weight: 900;
  margin-right: 8px;
}
.h-x{
  width: 30px;
  height: 26px;
  border: 0;
  background: #BC1E2D;
  color: #FFFFFF;
  cursor: pointer;
  font-weight: 900;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bm-body{
  width: 309px;
  height: 306px;
  padding: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.wraper-info {
  padding: 5px 15px 0;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
}
.info-table td {
  text-align: center;
  font-weight: bold;
  color: #000;
  padding: 0;
  height: 22px;
}
.ti-play { font-size: 18px; line-height: 22px; }
.ti-time { font-size: 14px; line-height: 22px; }
.ti-range { font-size: 16px; line-height: 22px; }
.ti-odds { font-size: 16px; line-height: 22px; }

/* === Stake === */
.stake-bar-v3{
  width: 260px;
  height: 42px;
  margin: 5px auto;
  background-color: #5680cd;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.stake-text{
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  padding-right: 8px;
}

.stake-input-v3{
  width: 120px;
  height: 24px;
  border: 1px solid #7a7a7a;
  outline: none;
  background: linear-gradient(to bottom, #999, #fff); 
  color: #000;
  font-weight: bold;        
  font-size: 16px;          
  text-align: center;       
  box-sizing: border-box;   
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.3);
}

.chips{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 5px 10px;
  gap: 0;
}
.button-bet{
  width: 55px;
  height: 55px;
  margin: 3px 6px;
  background-color: #5680cd;
  color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 2px 2px 3px #2F4C81;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.title-button-bet {
  font-size: 13px;
  font-weight: bold;
}

.bm-hr {
  width: 90%;
  margin: 5px auto;
  border: 0;
  border-top: 1px solid #000;
}

.bm-info{
  padding-left: 20px;
}
.max-payout-line {
  margin: 1px 0;
  font-size: 13px;
  color: #000;
  font-weight: bold;
}
.val { font-weight: normal; }
.limit{ color:#c81919; font-weight: bold; }

/* ✅ 底部按钮：309*43 */
.bm-actions{
  width: 309px;
  height: 43px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-top: 1px solid #ccc;
}
.btn{
  width: 67px;
  height: 34px;
  border: 0;
  cursor: pointer;
  font-weight: bold;
  color: #fff;
  font-size: 14px;
  border-radius: 2px;
}
.btn.bet{ background:#5680CD; }
.btn.cancel{ background:#BC1E2D; }
.btn.reset{ background:#8C8E92; }

</style>
